"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icons = _interopRequireDefault(require("../baseComponents/Icons"));
var _CheckboxRadio = _interopRequireDefault(require("../baseComponents/CheckboxRadio"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var DataTable = /*#__PURE__*/function (_Component) {
  function DataTable(props) {
    var _this;
    _classCallCheck(this, DataTable);
    _this = _callSuper(this, DataTable, [props]);
    _this.state = {
      selectedColIndex: props.selectedColIndex,
      sort: props.sort,
      selectedRowIndex: props.selectedRowIndex,
      selectAllChecked: props.selectAllChecked
    };
    _this.handleHeadingClick = _this.handleHeadingClick.bind(_this);
    _this.handleRowSelect = _this.handleRowSelect.bind(_this);
    _this.fillHeader = _this.fillHeader.bind(_this);
    _this.fillContent = _this.fillContent.bind(_this);
    _this.toggleSelectAll = _this.toggleSelectAll.bind(_this);
    return _this;
  }
  _inherits(DataTable, _Component);
  return _createClass(DataTable, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var newSelectedLength = this.props.selectedRowsIds.length;
      if (this.props.checkSelectionById && prevProps.selectedRowsIds.length !== newSelectedLength) {
        var _this$props$tableCont;
        if (newSelectedLength === ((_this$props$tableCont = this.props.tableContent) === null || _this$props$tableCont === void 0 ? void 0 : _this$props$tableCont.length)) {
          this.toggleSelectAll(true);
        } else if (newSelectedLength === 0) {
          this.toggleSelectAll(false);
        }
      }
    }
  }, {
    key: "handleHeadingClick",
    value: function handleHeadingClick(e, index, colExtra) {
      var sorting = "";
      if (this.props.enableSort) {
        sorting = this.state.sort;
        var isSwitching = this.state.selectedColIndex !== index;
        if (isSwitching) {
          sorting = 'desc';
        }
        if (this.state.selectedColIndex != null && !isSwitching) {
          if (this.state.sort === 'asc') {
            sorting = 'desc';
          } else {
            sorting = 'asc';
          }
        }
        this.setState({
          selectedColIndex: index,
          sort: sorting
        });
      }
      if (this.props.onHeadingClick) {
        this.props.onHeadingClick(e, index, sorting, colExtra);
      }
    }
  }, {
    key: "toggleSelectAll",
    value: function toggleSelectAll() {
      var forceState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.setState({
        selectAllChecked: forceState !== null ? forceState : !this.state.selectAllChecked
      });
    }
  }, {
    key: "setRowIndexes",
    value: function setRowIndexes(rowsIndexes) {
      this.setState({
        selectedRowIndex: rowsIndexes
      });
    }
  }, {
    key: "handleRowSelect",
    value: function handleRowSelect(e, rowIndex) {
      var selectAll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var rowExtra = arguments.length > 3 ? arguments[3] : undefined;
      var rowsIndexes = this.state.selectedRowIndex;
      if (selectAll) {
        rowsIndexes = [];
        var rowCount = this.props.tableContent.length;
        if (this.props.selectingIcon) {
          for (var i = 0; i < rowCount; i++) {
            rowsIndexes.push(i);
          }
          this.setRowIndexes(rowsIndexes);
          return;
        } else {
          if (this.state.selectAllChecked) {
            rowsIndexes = [];
            this.setRowIndexes(rowsIndexes);
            this.toggleSelectAll();
            if (this.props.onDataSelect) {
              this.props.onDataSelect(e, selectAll ? "none" : rowIndex, rowsIndexes, rowExtra);
            }
            return;
          } else {
            for (var _i = 0; _i < rowCount; _i++) {
              rowsIndexes.push(_i);
            }
            this.toggleSelectAll();
          }
        }
      } else {
        var foundRowIndex = rowsIndexes.indexOf(rowIndex);
        if (foundRowIndex === -1) {
          rowsIndexes.push(rowIndex);
        } else {
          rowsIndexes.splice(foundRowIndex, 1);
        }
        if (rowsIndexes.length === 0 && this.state.selectAllChecked) {
          this.toggleSelectAll(false);
        }
        if (this.props.tableContent.length === rowsIndexes.length) {
          this.toggleSelectAll(true);
        }
      }
      this.setRowIndexes(rowsIndexes);
      if (this.props.onDataSelect) {
        this.props.onDataSelect(e, selectAll ? "all" : rowIndex, rowsIndexes, rowExtra);
      }
    }
  }, {
    key: "fillHeader",
    value: function fillHeader(content, isSticky) {
      var _this2 = this;
      var header = content.map(function (col, index) {
        var colIndex = isSticky ? _this2.props.headerContent.length - _this2.props.lastStickyColumnCount + index : index;
        var sorting = _this2.state.selectedColIndex === colIndex && _this2.props.enableSort;
        var headerColClasses = (0, _classnames["default"])("dataTable-header-col", "dataTable-col", col.className, _defineProperty(_defineProperty(_defineProperty({
          "isSorting": sorting,
          "notSortable": col.notSortable === true
        }, _this2.state.sort, sorting), "stickyHead", isSticky), "withBorders", _this2.props.withBorders));
        var onClick = {
          onClick: function onClick(e) {
            _this2.handleHeadingClick(e, colIndex, col.extra);
          }
        };
        if (col.notSortable === true) {
          onClick = null;
        }
        return /*#__PURE__*/_react["default"].createElement("div", _extends({
          className: headerColClasses,
          style: col.style,
          key: "header-col-".concat(colIndex)
        }, onClick), col.content, col.notSortable !== true && /*#__PURE__*/_react["default"].createElement("div", {
          className: "iconContainer"
        }, _this2.props.sortingIcon ? _this2.props.sortingIcon : /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
          name: "micro-glyph-arrow"
        })));
      });
      if (this.props.selectableData && !isSticky) {
        header.unshift(/*#__PURE__*/_react["default"].createElement("div", {
          key: "header-select-col",
          className: "dataTable-col dataTable-select-col",
          onClick: function onClick(e) {
            _this2.handleRowSelect(e, null, true);
          }
        }, this.props.selectingIcon ? this.props.selectingIcon : /*#__PURE__*/_react["default"].createElement(_CheckboxRadio["default"], {
          type: "checkbox",
          checked: this.state.selectAllChecked
        })));
      }
      return header;
    }
  }, {
    key: "fillContent",
    value: function fillContent(content) {
      var _this3 = this;
      var hasSticky = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var isSticky = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return content.map(function (rowEl, rowIndex) {
        var isSelected = _this3.props.checkSelectionById ? _this3.props.selectedRowsIds.indexOf((rowEl.extra || {}).id) !== -1 && _this3.props.selectableData : _this3.state.selectedRowIndex.indexOf(rowIndex) !== -1 && _this3.props.selectableData;
        var rowClasses = (0, _classnames["default"])("dataTable-row", "dataTable-content-row", rowEl.className, {
          "selected": isSelected
        });
        var iterableRow;
        if (hasSticky) {
          iterableRow = isSticky ? rowEl.cols.slice(rowEl.cols.length - _this3.props.lastStickyColumnCount) : rowEl.cols.slice(0, -_this3.props.lastStickyColumnCount);
        } else {
          iterableRow = rowEl.cols;
        }
        var cols = iterableRow.map(function (colEl, colIndex) {
          var actualColIndex = isSticky ? _this3.props.headerContent.length - _this3.props.lastStickyColumnCount + colIndex : colIndex;
          var sorting = _this3.state.selectedColIndex === actualColIndex && _this3.props.enableSort;
          var colClasses = (0, _classnames["default"])("dataTable-col", "dataTable-content-col", colEl.className, {
            "isSorting": sorting,
            "stickyCol": isSticky,
            "withBorders": _this3.props.withBorders,
            "clickableRow": _this3.props.onRowClick && colEl.notClickable !== true
          });
          var onClick = null;
          if (_this3.props.onRowClick && colEl.notClickable !== true) {
            onClick = {
              onClick: function onClick(e) {
                _this3.props.onRowClick(e, rowIndex, rowEl.extra, colEl.extra);
              }
            };
          }
          return /*#__PURE__*/_react["default"].createElement("div", _extends({
            className: colClasses,
            style: colEl.style,
            key: "row-col-".concat(actualColIndex)
          }, onClick), colEl.content);
        });
        if (_this3.props.selectableData && !isSticky) {
          cols.unshift(/*#__PURE__*/_react["default"].createElement("div", {
            key: "tableContent-select-col",
            className: "dataTable-col dataTable-select-col"
          }, /*#__PURE__*/_react["default"].createElement(_CheckboxRadio["default"], {
            type: "checkbox",
            checked: isSelected,
            onChange: function onChange(e) {
              _this3.handleRowSelect(e, rowIndex, false, rowEl.extra);
            }
          })));
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: rowClasses,
          key: "row-".concat(rowIndex),
          style: rowEl.style
        }, cols);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var classes = (0, _classnames["default"])(this.props.className, "dataTable-component", this.props.typeStyle, {
        "sortable": this.props.enableSort,
        "selectableRow": this.props.selectableData,
        "hasStickyColumn": this.props.lastStickyColumnCount
      });
      var colNumber = this.props.headerContent.length;
      var headerContent, tableContent, stickyHeaderContent, stickyTableContent;
      if (this.props.lastStickyColumnCount > 0) {
        headerContent = this.fillHeader(this.props.headerContent.slice(0, -this.props.lastStickyColumnCount));
        tableContent = this.fillContent(this.props.tableContent, true);
        if (this.props.selectingIcon || this.props.selectableData) {
          stickyHeaderContent = this.fillHeader(this.props.headerContent.slice(colNumber - this.props.lastStickyColumnCount), true);
          stickyTableContent = this.fillContent(this.props.tableContent, true, true);
        } else {
          stickyHeaderContent = this.fillHeader(this.props.headerContent.slice(colNumber - this.props.lastStickyColumnCount), true);
          stickyTableContent = this.fillContent(this.props.tableContent, true, true);
        }
      } else {
        headerContent = this.fillHeader(this.props.headerContent);
        tableContent = this.fillContent(this.props.tableContent);
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classes,
        style: this.props.style
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "dataTable"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "dataTable-container"
      }, colNumber > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: "dataTable-header dataTable-row"
      }, headerContent), tableContent)), this.props.lastStickyColumnCount > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: "dataTable"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "dataTable-container sticky-container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "dataTable-container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "dataTable-header dataTable-row"
      }, stickyHeaderContent), stickyTableContent))));
    }
  }]);
}(_react.Component);
;
DataTable.propTypes = {
  headerContent: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    content: _propTypes["default"].any,
    style: _propTypes["default"].object,
    // minWidth is used for size
    className: _propTypes["default"].string,
    isSorting: _propTypes["default"].bool,
    extra: _propTypes["default"].any,
    notSortable: _propTypes["default"].bool
  })),
  tableContent: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    extra: _propTypes["default"].any,
    className: _propTypes["default"].string,
    style: _propTypes["default"].object,
    cols: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      content: _propTypes["default"].any,
      style: _propTypes["default"].object,
      className: _propTypes["default"].string,
      extra: _propTypes["default"].any,
      notClickable: _propTypes["default"].bool
    }))
  })),
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  enableSort: _propTypes["default"].bool,
  selectedColIndex: _propTypes["default"].number,
  sortingIcon: _propTypes["default"].object,
  onHeadingClick: _propTypes["default"].func,
  selectableData: _propTypes["default"].bool,
  onDataSelect: _propTypes["default"].func,
  selectedRowIndex: _propTypes["default"].arrayOf(_propTypes["default"].number),
  selectingIcon: _propTypes["default"].object,
  lastStickyColumnCount: _propTypes["default"].number,
  selectAllChecked: _propTypes["default"].bool,
  withBorders: _propTypes["default"].bool,
  onRowClick: _propTypes["default"].func,
  sort: _propTypes["default"].oneOf(['asc', 'desc']),
  typeStyle: _propTypes["default"].oneOf(["default", "minimal"]),
  checkSelectionById: _propTypes["default"].bool,
  selectedRowsIds: _propTypes["default"].array
};
DataTable.defaultProps = {
  headerContent: [],
  tableContent: [],
  className: "",
  style: {},
  enableSort: false,
  selectedColIndex: null,
  // tell witch index is the colum sorting
  sortingIcon: null,
  // default icon override
  onHeadingClick: null,
  selectableData: false,
  onDataSelect: null,
  selectedRowIndex: [],
  // preselected rows
  selectingIcon: null,
  // selectingIcon icon override
  lastStickyColumnCount: 0,
  selectAllChecked: false,
  withBorders: false,
  onRowClick: null,
  sort: "asc",
  typeStyle: "default",
  checkSelectionById: false,
  selectedRowsIds: []
};
var _default = exports["default"] = DataTable;